import "core-js/modules/es6.object.assign";
import React from 'react';
import { Link } from 'gatsby';
import Bio from '../components/bio';
import Layout from '../components/layout';
import SEO from '../components/seo';
import { rhythm, scale } from '../utils/typography';
var BlogPostTemplate = function BlogPostTemplate(_ref) {
    var data = _ref.data, pageContext = _ref.pageContext, location = _ref.location;
    var post = data.markdownRemark;
    var siteTitle = data.site.siteMetadata.title;
    var previous = pageContext.previous, next = pageContext.next;
    return /*#__PURE__*/ React.createElement(Layout, {
        location: location,
        title: siteTitle
    }, /*#__PURE__*/ React.createElement(SEO, {
        title: post.frontmatter.title,
        description: post.frontmatter.description || post.excerpt
    }), /*#__PURE__*/ React.createElement("article", {
        className: "prose"
    }, /*#__PURE__*/ React.createElement("header", null, /*#__PURE__*/ React.createElement("h1", {
        style: {
            marginTop: rhythm(1),
            marginBottom: 0
        }
    }, post.frontmatter.title), /*#__PURE__*/ React.createElement("p", {
        style: Object.assign({}, scale(-1 / 5), {
            display: "block",
            marginBottom: rhythm(1)
        })
    }, post.frontmatter.date)), /*#__PURE__*/ React.createElement("section", {
        dangerouslySetInnerHTML: {
            __html: post.html
        }
    }), /*#__PURE__*/ React.createElement("hr", {
        style: {
            marginBottom: rhythm(1)
        }
    }), /*#__PURE__*/ React.createElement("footer", null, /*#__PURE__*/ React.createElement(Bio, null))), /*#__PURE__*/ React.createElement("nav", {
        className: "my-10"
    }, /*#__PURE__*/ React.createElement("ul", {
        style: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            listStyle: "none",
            padding: 0
        }
    }, /*#__PURE__*/ React.createElement("li", null, previous && /*#__PURE__*/ React.createElement(Link, {
        to: previous.fields.slug,
        rel: "prev"
    }, "\u2190 ", previous.frontmatter.title)), /*#__PURE__*/ React.createElement("li", null, next && /*#__PURE__*/ React.createElement(Link, {
        to: next.fields.slug,
        rel: "next"
    }, next.frontmatter.title, " \u2192")))));
};
export default BlogPostTemplate;
export var pageQuery = "10472337";
